import getFeeByDay from "../getFeeByDay";
import priceToMonedaElegida from "../priceToMonedaElegida";

const getPriceFromDays = (
    date,
    arrayDias,
    moneda_precio_base,
    arrayFees,
    fee_cliente_siempre,
    fee_propietario_siempre
) => {
    let response = {};

    arrayDias.some((day) => {
        if (date.getDay() === day.dia) {
            let ambos_fee = {
                fee_cliente: Number(
                    day.precio / (1 - fee_cliente_siempre / 100) - day.precio
                ),
            };

            if (arrayFees.length > 0) {
                ambos_fee = getFeeByDay(
                    date,
                    arrayFees,
                    fee_cliente_siempre,
                    fee_propietario_siempre,
                    day.precio
                );
            }

            return (response = {
                hasProperty: true,
                total: day.precio,
                fee_cliente: ambos_fee.fee_cliente,
                fee_propietario: ambos_fee.fee_propietario,
                tiene_fee_por_fecha: ambos_fee.tiene_fee_por_fecha,
            });
        } else {
            response = {
                hasProperty: false,
            };
        }
    });

    return response;
};

export default getPriceFromDays;
